import React from "react";
import classNames from "classnames";
import { Button } from "@design-system/Button/Button";
import { Picker } from "@design-system/Picker/Picker.lib";
import type { PickerItemData } from "@design-system/Picker/Picker.types";
import { LeftArrowIcon } from "@icons";
import styles from "./RuleTransactionsPreview.module.scss";

export type TransferPreviewMode = "matching" | "applied";

interface TransferRuleTransactionPreviewHeaderProps {
    totalTransactions: number;
    onExpand?: () => void;
    className?: string;
    expanded?: boolean;
    isEditMode: boolean;
    previewMode: TransferPreviewMode;
    onPreviewModeChange: (mode: TransferPreviewMode) => void;
    appliedCount: number;
}

export const TransferRuleTransactionPreviewHeader: React.FC<
    TransferRuleTransactionPreviewHeaderProps
> = ({
    totalTransactions,
    onExpand,
    className,
    expanded,
    isEditMode,
    previewMode,
    onPreviewModeChange,
    appliedCount,
}) => {
    const matchingLabel = `Matching conditions (${totalTransactions})`;
    const appliedLabel = `Was applied to (${appliedCount})`;
    const previewModeItems: Array<PickerItemData<TransferPreviewMode>> = [
        { value: "matching", label: matchingLabel },
        { value: "applied", label: appliedLabel },
    ];
    const showExpandButton =
        previewMode === "matching" ? totalTransactions > 0 : appliedCount > 0;

    return (
        <div
            className={classNames(styles.previewHeader, className, {
                [styles.expanded]: expanded,
            })}
        >
            {showExpandButton && (
                <Button
                    variant="primary"
                    size="sm"
                    iconOnly
                    aria-label={
                        expanded ? "Collapse preview" : "Expand preview"
                    }
                    type="button"
                    onClick={onExpand}
                >
                    <LeftArrowIcon />
                </Button>
            )}
            {isEditMode ? (
                <Picker.Select
                    items={previewModeItems}
                    value={previewMode}
                    onValueChange={(value) => {
                        if (value !== null) {
                            onPreviewModeChange(value);
                        }
                    }}
                    trigger={<Picker.Button variant="secondary" size="sm" />}
                />
            ) : (
                <span className={styles.previewHeaderText}>
                    {matchingLabel}
                </span>
            )}
        </div>
    );
};
